function useKeyword(key = "keyword") {
  const currentUrl = window.location.href;
  let urlParams = new URLSearchParams(new URL(currentUrl).search);
  return urlParams.get(key);
}

export default useKeyword;
